import { $get } from '../base'

/**
 * 获取帮助中心-常见问题列表
 * @returns
 */
export function getQuestionList(params) {
  return $get('/helpcenter/api/frequent/', params)
}

/**
 * 获取合作伙伴列表
 * @returns
 */
export function getPartnerList() {
  return $get('/partner/')
}
/**
 * 获取市场合作联系人
 * @returns
 */
export function getCommerceContact() {
  return $get('/api/home_page/commerce_contact/')
}
